var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"Auth"},[_c('div',{staticClass:"Auth__Inner"},[_vm._m(0),_c('div',{staticClass:"Auth__FormWrapper"},[_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"Auth__Image"},[_c('img',{staticClass:"logo",attrs:{"alt":"Logo","src":require("@/assets/img/logo.png")}})])
}]

export { render, staticRenderFns }